import React from 'react';
import { Card } from './ui/card';
import { Activity, Droplet, HeartPulse, ShieldPlus, Shield, Heart } from 'lucide-react';

const iconMap = {
  activity: Activity,
  droplet: Droplet,
  'heart-pulse': HeartPulse,
  'shield-plus': ShieldPlus,
  shield: Shield,
  heart: Heart
};

const ClinicalExpertise = ({ expertise }) => {
  return (
    <section id="expertise" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Clinical Expertise
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Specialized areas of medical practice with proven excellence in pediatric care
            </p>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {expertise?.map((item, idx) => {
              const IconComponent = iconMap[item.icon] || Activity;
              return (
                <Card
                  key={idx}
                  className="p-6 border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 group cursor-pointer"
                >
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="p-4 bg-teal-100 rounded-xl group-hover:bg-teal-600 group-hover:scale-110 transition-all duration-300">
                      <IconComponent className="w-8 h-8 text-teal-600 group-hover:text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClinicalExpertise;